<div class="wrapper__headerComponent container my-5">
  <div class="container mt-5">
    <ng-container *ngIf="esSuperAdmin">
      <div class="d-flex justify-content-end mb-3">
        <button
          class="btn-govco fill-btn-govco hvr-shrink ms-2"
          (click)="redirigirAdm()">
          Administrar
        </button>
      </div>
    </ng-container>
    <div class="report-header row">
      <h1 class="col-12 col-md-3">Portal de datos</h1>
      <div class="col-12 col-md-9 d-none d-md-block">
        <img
          src="assets/img/741Cabezote1Tam260x260.png"
          alt="Portal de Datos" />
      </div>
    </div>
    <div class="row align-items-center">
      <app-power-bi-embed
        #reporte
        *ngIf="renderizarReporte"
        [embedUrl]="embedUrl"
        [embebedToken]="embedToken"
        [reportId]="reportId"
        [groupId]="groupId"
        [accessToken]="accessToken"
        [heigth]="height"
        [isZoomEnabled]="isZoomEnabled"
        [isMobile]="isMobile">
      </app-power-bi-embed>
    </div>
    <div class="report-footer">
      <div class="row">
        <div class="col-12 col-md-6 report-footer-imgdiv d-none d-md-block">
          <img src="assets/img/741Pie1Tam540x200.png" alt="Resultados" />
        </div>
        <div class="col-12 col-md-6">
          <div class="row report-footer-total">
            <h2 class="col-12 col-md-8">
              Total de procesos gestionados a través de Justifacil
            </h2>
            <label class="col-12 col-md-4">{{ totalDatos }}</label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="row report-footer-description">
          <p>{{ descripcion }}</p>
        </div>
      </div>
      <div class="report-footer-download">
        <ng-container *ngIf="!downloadFlag">
          <div class="col-12 col-md-4 d-none d-md-block"></div>
          <div class="col-12 col-md-4">
            <button
              class="btn-govco outline-btn-govco hvr-shrink report-footer-download-bton"
              (click)="downloadTable()">
              Descarga de la base de datos
            </button>
          </div>
          <div
            class="col-12 col-md-4 report-footer-download-imgdiv d-none d-md-block">
            <img
              class="report-footer-download-img"
              src="assets/img/741Pie2Tam540x200.png"
              alt="Descraga de base de datos" />
          </div>
        </ng-container>
        <ng-container *ngIf="downloadFlag">
          <app-download-db
            [reportMetaDB]="reportMetaId"
            [reportRef]="this"></app-download-db>
        </ng-container>
      </div>
    </div>
  </div>
</div>
